import tenantAxiosInstance from '../utils/tenantAxiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getHomepageDetails = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/homepage`)
    .then((response) => {
      return response.data;
    });
};

const personalDetails = (tenant_id, user_id) => {
  const bodyVal =  {
    "user_id": user_id
  };
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/user_personal_settings`,bodyVal)
    .then((response) => {
      return response.data;
    });
};

const updatePersonalDetail = (tenant_id, user_id, body) => {
  return tenantAxiosInstance
    .put(API_URL + `${tenant_id}/personal_settings`, body)
    .then((response) => {
      return response.data;
    });
};

const getCompanyBasicDetails = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/basic_details`)
    .then((response) => {
      return response.data;
    });
};

const getTeamMembers = (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `${tenant_id}/team_list`)
    .then((response) => {
      return response.data;
    });
};

const deleteTeamMembers = (tenant_id, user_id) => {
  return tenantAxiosInstance
    .delete(API_URL + `${tenant_id}/delete_user/${user_id}`)
    .then((response) => {
      return response.data;
    });
};

const addTeamMembers = (body, tenant_id) => {
  return tenantAxiosInstance
    .post(API_URL + `${tenant_id}/create_user`, body)
    .then((response) => {
      return response.data;
    });
};

const getPlansBillings = () => {
  return tenantAxiosInstance
    .get(API_URL + 'plans_billings')
    .then((response) => {
      return response.data;
    });
};

const acceptTerms = (tenant_id) => {
  return tenantAxiosInstance
    .put(API_URL + `${tenant_id}/accept-terms`, { accept_status: true })
    .then((response) => {
      response?.data?.user_details?.has_accepted_terms &&
        localStorage.setItem('brandUser', JSON.stringify(response.data));
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error);
      throw error;
    });
};

const TenantSettingService = {
  getHomepageDetails,
  personalDetails,
  updatePersonalDetail,
  getCompanyBasicDetails,
  getTeamMembers,
  deleteTeamMembers,
  addTeamMembers,
  getPlansBillings,
  acceptTerms,
};

export default TenantSettingService;
